import React, {useMemo} from "react";
import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {useFiltered, useFilters} from "@atttomyx/shared-hooks";
import {BulkEmailForm} from "../forms";
import {sorting, strings} from "@atttomyx/shared-utils";
import {nodeUtils} from "../../utils";
import {BULK_EMAIL_FILTERS} from "../../filters";

const BulkEmailDialog = (props) => {
    const {user, unique, nodes, onCancel} = props;
    const filters = useFilters(BULK_EMAIL_FILTERS);
    const filtered = useFiltered(nodes, filters, sorting.sortByLastNameAndFirstName);

    const bcc = useMemo(() => {
        return strings.isBlank(filters.data.email) ? 0 : filtered.length;
    }, [filters.data.emailExists, filtered.length]);

    return <Dialog
        open={true}
        aria-labelledby="bulk-email-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Bulk Email
        </ClosableDialogTitle>
        <DialogContent>
            <BulkEmailForm
                unique={unique}
                data={filters.data}
                onChange={filters.setData}
            />
        </DialogContent>
        <DialogActions>
            <Button
                color="primary"
                disabled={bcc < 1}
                onClick={() => nodeUtils.popBulkEmail(user, filtered, filters.data.email)}
            >
                BCC ({bcc})
            </Button>
        </DialogActions>
    </Dialog>
}

export default BulkEmailDialog;
